import PropTypes from 'prop-types';
import JawsComponent from 'components/JawsComponent';
import jawsConnect from 'utils/jawsConnect';
import objectAssign from 'object-assign';

import * as UserUtils from 'utils/user';
import * as CustomerUtils from 'utils/customer';

class PortfolioFetcher extends JawsComponent {
  spec = {
    type: 'secure/portfolio',
    columns: [
      'ITEM_SECTOR,ITEM,LAST,CHANGE,CHANGE_PCT,POSITION_VOLUME,TIME',
    ].join(','),
    backend: 'probroker',
    fromDate: 'firstDayOfYear',
    toDate: 'now',
  };

  static propTypes = {
    item: PropTypes.object.isRequired,
    portfolioId: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    user: PropTypes.any.isRequired,
    render: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.spec = objectAssign({}, this.spec, {
      portfolioId: this.props.portfolioId,
      userId: this.props.userId,
    });
    this.subscribe();
  }

  componentWillReceiveProps({ item: nextItem }) {
    const prevItem = this.props.item;
    const { user } = this.props;
    const customer = UserUtils.getCustomerData(user);
    const selectedAccount = CustomerUtils.getSelectedAccount(customer);
    const newPortfolioId = selectedAccount.get('customerId');

    if (
      prevItem.ITEM !== nextItem.ITEM ||
      this.spec.portfolioId !== newPortfolioId
    ) {
      this.portfolioId = newPortfolioId;

      this.spec = objectAssign({}, this.spec, {
        portfolioId: this.props.portfolioId,
        userId: this.props.userId,
      });

      this.resubscribe();
    }
  }

  render() {
    const key = `${this.props.item.ITEM.replace('-', '_')}_SSE`;
    const portfolio = this.props.items.toJS();
    const item = portfolio[key] ? portfolio[key].values : {};

    return this.props.render({
      portfolio,
      item,
      holding: item.POSITION_VOLUME,
    });
  }
}

export { PortfolioFetcher };
export default jawsConnect(PortfolioFetcher);
